import React, { useState, useRef } from "react";
import {
  StyleSheet,
  View,
  Image,
  TouchableOpacity,
  ActivityIndicator,
} from "react-native";
import Buttons from "components/Buttons";
import VText from "components/VText";
import { Images } from "assets";
import { fp, hp, wp } from "utils/normalizeV2";
import { Colors } from "colors";
import { useDispatch, useSelector } from "react-redux";
import { addToFavourite, deleteFavourite } from "appRedux/reducers/cartSlice";
import SimilarProducts from "./../similarProducts";
import { useLocalSearchParams } from "expo-router";

const FavDislikeCardComponent = ({
  item,
  showViewSimilar = true,
  marginRight = wp(15),
}) => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.AuthReducer.userId);
  const favouriteProductIds =
    useSelector((state) => state.HomeReducer.favouriteProductIds) || [];
  const isFavourite = favouriteProductIds.includes(
    item?.id || item?._id || item?.productId
  );
  const [loading, setLoading] = useState(false);
  const _similarProductsRef = useRef();
  const local = useLocalSearchParams();
  const gender = local?.gender ?? "female";
  const [similarProduct, setSimilarProduct] = useState(null);

  const showSimilarProducts = (item) => {
    setSimilarProduct(item);
    _similarProductsRef?.current?.show();
  };

  return (
    <View style={styles.carouselItem}>
      <TouchableOpacity
        onPress={() => {
          window.open(
            `/product?id=${item?.id}&brand=${item?.brandName}&product=${item?.productName}&gender=${gender}`,
            "_blank"
          );
        }}
      >
        <Image
          source={{ uri: item?.imageUrls[0] }}
          style={[styles.carouselImage, { marginRight: marginRight }]}
          resizeMode="cover"
        />
      </TouchableOpacity>
      {/* <TouchableOpacity style={styles.dislikeButton}>
                <Image source={Images.dislike} style={styles.actionIcon} />
            </TouchableOpacity> */}
      <TouchableOpacity
        onPress={() => {
          const data = {
            userId,
            productId: item?.id || item?._id || item?.productId,
          };
          if (isFavourite) {
            setLoading(true);
            dispatch(deleteFavourite(data))
              .then((res) => {
                if ([200].includes(res?.payload?.status)) {
                  dispatch(getFavProducts()).then(() => {
                    setLoading(false);
                  });
                } else {
                  setLoading(false);
                  alert("Error");
                }
              })
              .catch((err) => {
                setLoading(false);
                alert("Error");
              });
          } else {
            setLoading(true);
            dispatch(addToFavourite(data))
              .then((res) => {
                if ([200].includes(res?.payload?.data?.data?.statusCode)) {
                  dispatch(getFavProducts()).then(() => {
                    setLoading(false);
                  });
                } else {
                  setLoading(false);
                  alert("Error");
                }
              })
              .catch((err) => {
                setLoading(false);
                alert("Error");
              });
          }
        }}
        style={styles.favouriteButton}
      >
        {/* <Image source={isFavourite ? Images.selectedFavourite : Images.favourite} style={styles.actionIcon} /> */}
        {loading && <ActivityIndicator size="small" color={Colors.black} />}
        {!loading && (
          <Image
            source={isFavourite ? Images.selectedFavourite : Images.favourite}
            style={styles.actionIcon}
          />
        )}
      </TouchableOpacity>
      <View style={styles.carouselItemDetails}>
        {showViewSimilar && (
          <Buttons
            onPress={() => showSimilarProducts(item)}
            containerStyle={styles.carouselViewSimilarButton}
            text="View Similar"
            isInverse
          />
        )}
        <VText style={styles.carouselBrandText}>{item?.brandName}</VText>
        <VText style={styles.carouselNameText} numberOfLines={2}>
          {item?.productName}
        </VText>
        <VText style={styles.carouselPriceText}>${item?.productPrice}</VText>
      </View>

      <SimilarProducts ref={_similarProductsRef} product={similarProduct} />
    </View>
  );
};

const styles = StyleSheet.create({
  carouselItem: {
    width: wp(190),
    height: hp(353),
    backgroundColor: Colors.white,
    borderRadius: fp(8),
  },
  carouselImage: {
    height: hp(213),
    marginRight: wp(15),
  },
  dislikeButton: {
    position: "absolute",
    top: hp(8),
    left: wp(8),
  },
  favouriteButton: {
    position: "absolute",
    top: hp(8),
    right: wp(20),
  },
  carouselItemDetails: {
    marginRight: wp(15),
    paddingVertical: hp(10),
    backgroundColor: Colors.white,
  },
  carouselViewSimilarButton: {
    backgroundColor: Colors.white,
    borderRadius: fp(4),
    marginBottom: hp(8),
    borderWidth: 1,
    borderColor: "#21242729",
    height: hp(40),
  },
  carouselViewSimilarText: {
    fontSize: fp(12),
    fontWeight: "500",
    color: Colors.textPrimary,
  },
  carouselBrandText: {
    fontSize: fp(16),
    fontWeight: "700",
    marginTop: hp(10),
    marginBottom: hp(4),
  },
  carouselNameText: {
    fontSize: fp(16),
    fontWeight: "300",
    marginBottom: hp(4),
  },
  carouselPriceText: {
    fontSize: fp(14),
    fontWeight: "500",
    marginBottom: hp(4),
  },
  actionIcon: {
    width: wp(17),
    height: wp(17),
  },
});

export default React.memo(FavDislikeCardComponent);
